import NavMenu from '../views/pages/Shared/NavMenu.vue';
import { RequestStore, RequestView } from '../views/pages/Request';
import VRequestCreateModal from '../views/modals/VRequestCreateModal.vue';

export default [
    //aliases for legacy routing
    {
        path: '/',
        redirect: '/request/inbox',
    },
    {
        path: '/feed/:method?/:id?',
        redirect: '/request/:method?/:id?',
    },

    {
        name: 'request',
        path: '/request/:method(inbox|outbox|archive|store|view|my|\\d+)?/:id?',
        components: {
            menu: NavMenu,
            default: RequestStore,
            sharedPanel: RequestView,
            VRequestCreateModal,
        },
    },
];
